import { SerpDisplayType } from '~/analytics/ActionAnalytics/actions/actionTypes';
import { SERPConfirmationEventType, SERPEvent, SERPEventType } from '../SERPEvents';

export type CloseEventDetail = {
    data: {
        searchQuery: string;
        resultsCount: number;
        loadingFinished: boolean;
        serpType: SerpDisplayType;
    };
    deliveryConfirmations: [SERPConfirmationEventType.CLOSE_AA_CONFIRM];
};

export type SERPCloseEvent = CustomEvent<CloseEventDetail> & {
    type: SERPEventType.CLOSE;
};

export const isCloseEvent = (event: SERPEvent): event is SERPCloseEvent => {
    return (
        event.type === SERPEventType.CLOSE &&
        'data' in event.detail &&
        typeof event.detail.data === 'object' &&
        event.detail.data.searchQuery !== undefined &&
        event.detail.data.resultsCount !== undefined &&
        event.detail.data.loadingFinished !== undefined
    );
};
